import { useTranslation } from "react-i18next";
import {
  ActorIcon,
  DownloadIcon,
  GenerateIcon,
  VideoIcon,
} from "@/components/ui/icon";
import { ChooseProjectModal } from "@/components/common/choose-project-modal";
import { TextButton } from "@/components/common/text-button";
import { cn } from "@/lib/utils";
import { TimeIcon } from "@/components/assets/assets";
import { formatDateSmart } from "@/utils/date-formatter";

interface PanelParams {
  actor: Actor;
  onDownload: () => void;
}

export default function Panel({
  actor,
  onDownload,
}: PanelParams) {
  const { t } = useTranslation();

  return (
    <div className="w-88 bg-i-white flex flex-col gap-4 p-6">
      {/* Actor */}
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <ActorIcon className="w-4 h-4 text-i-sub" />
          <span className="text-sm text-i-sub">{t("modal_video_play.panel.actor")}</span>
        </div>
        <p className="text-sm text-i-black text-medium">{actor.name}</p>
      </div>

      {/* Voice */}
      <div className="space-y-2">
        <div className="flex items-center gap-2">
          <VideoIcon className="w-4 h-4 text-i-sub" />
          <span className="text-sm text-i-sub">{t("modal_video_play.panel.voice")}</span>
        </div>
        <p className="text-sm text-i-black text-medium">{actor.audio.name}</p>
      </div>

      {/* Creation Time */}
      <div className="flex flex-col flex-1 space-y-2 overflow-auto">
        <div className="flex items-center gap-2">
          <TimeIcon className="w-4 h-4 text-i-sub" />
          <span className="text-sm text-i-sub">{t("modal_video_play.panel.creation_time")}</span>
        </div>
        <p className="flex-1 overflow-auto text-sm text-i-black text-medium">
          {formatDateSmart(actor.createdAt).replace("Today", t("creation_folder.project_card.today"))}
        </p>
      </div>

      {/* 操作按钮 */}
      <div className="flex gap-3 justify-end">
        <button
          onClick={() => onDownload()}
          disabled={actor.generateStatus !== 2}
          className="flex justify-center items-center gap-2 h-10 w-40 bg-i-white border border-[rgba(208,213,221,1)] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] rounded-sm transition-colors hover:bg-i-dorpdown"
        >
          <DownloadIcon className="w-4 h-4" />
          <span className="text-sm text-medium">{t("modal_video_play.panel.download")}{actor.status}</span>
        </button>
        {/* <ChooseProjectModal
          actor={actor}
          trigger={
            <TextButton
              onClick={(e) => {
                e.stopPropagation();
              }}
              icon={<GenerateIcon className="w-5 h-5" />}
              label={t("assets.apply")}
              disabled={actor.generateStatus !== 2}
              className={cn(
                "flex justify-center items-center gap-2 h-10 w-40 bg-i-normal shadow-[0px_1px_2px_rgba(16,24,40,0.05)] rounded-sm transition-colors hover:bg-[rgba(40,47,62,1)] text-sm"
              )}
            />
          }
        /> */}
      </div>
    </div>
  );
}
